import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { SPACING_REGULAR, SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const OfferPortalWorkflow = ({ className }: ClassAttributes<HTMLElement> & Props) => (
  <Root
    className={className}
    href="https://help.kaizen-ad.com/ja/collections/2210474"
    target="_blank"
    rel="noopener noreferrer"
  >
    <Heading variant="body2">投稿までの流れ</Heading>
    <Banner>
      <img src="assets/offerportal_workflow.svg" alt="offer portal workflow" />
    </Banner>
  </Root>
);

const Root = styled('a')({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  }),
  marginBottom: SPACING_UNIT,
  textDecoration: 'none',
});

const Banner = styled('div')({
  backgroundColor: '#fff',
  padding: `${SPACING_UNIT}px ${SPACING_REGULAR}px`,
});

const Heading = styled(Typography)({});

export default OfferPortalWorkflow;
